import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Box, Grid } from '@material-ui/core';
import { Accessories } from '../../../../common/graphql/fragments/deal/__generated__/Accessories';
import ItemDetails from '../itemDetails/ItemDetails';
import itemStyles from './itemStyles';

export interface ItemProps {
  item: Accessories;
  isChecked: boolean;
  handleSelectedItem: (accessory: number) => void;
}

const Item: FunctionComponent<ItemProps> = ({ item, isChecked, handleSelectedItem }) => {
  const styles = itemStyles();

  return (
    <Grid
      item
      xs={12}
      sm={6}
      lg={3}
      className={styles.itemContainer}
      data-test={'checkout:accessories:item'}
    >
      <Box
        className={clsx([
          styles.item,
          {
            [styles.itemSelected]: isChecked,
          },
        ])}
        data-test={`checkout:accessories:item:${item.code}`}
        onClick={() => { handleSelectedItem(item.id) }}
      >
        <ItemDetails
          item={item}
          isChecked={isChecked}
        />
      </Box>
    </Grid>
  );
};

export default Item;
